import React, { useState, useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  Box,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Select,
  Paper,
} from "@mui/material";
import "../../../styles/dashboard.scss";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../redux/slices/common.slice";
import Selectt from "react-select";
import CustomizedDialog from "../Dialog";
import {
  createServiceUnitTask,
  getAllServiceUnit,
  updateServiceUnitTask,
} from "../../../redux/slices/serviceUnit.slice";
import {
  createAudit,
  getAuditTemplates,
  updateAudit,
} from "../../../redux/slices/tenant.slice";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const BootstrapInput = {
  "& label": {
    width: "100%",
    "&.Mui-focused": {
      color: "#273167",
    },
  },
  "& .MuiOutlinedInput-root": {
    "& .Mui-disabled": {
      backgroundColor: "rgba(39, 49, 103, 0.1)",
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#273167 !important",
        borderWidth: "1px !important",
      },
    },
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#273167 !important",
        borderWidth: "1px !important",
      },
    },
  },
};
const severityOptions = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];
const customStyles = {
  control: (base, state) => ({
    ...base,
    border: "1px solid #ced4da",
    borderRadius: "4px",

    minHeight: "40px", // Mimicking MUI's small size
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: 180,
    overflowY: "auto",
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "rgba(25, 118, 210, 0.08)" // Highlight selected item with color
      : state.isFocused
      ? "#fafafa" // Hover effect
      : "white",
    color: "black",
    "&:active": {
      backgroundColor: "rgba(25, 118, 210, 0.08)",
    },
  }),
};

const CreateAudit = (
  {
    isOpenDrawer,
    setIsOpenDrawer,
    drawerState,
    values,

    getAllTasks,
  },
  props
) => {
  const [initialValues, setInitialValues] = useState({
    task_type: "audit_task",
    template_form: null,
    severity: { value: "low", label: "Low" },
    due_date: "",

    users: [],
    title: "",
    description: "",
  });

  const users = useSelector((state) => state.common.users);
  const [reviewCompleteOpen, setReviewCompleteOpen] = useState(false);
  const { id } = useParams();
  const [auditTemplates, setAuditTemplates] = useState();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const fetchAUDITTemplates = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(getAuditTemplates({ type: "audit" }));
      const { payload } = response;
      if (payload?.status) {
        setAuditTemplates(
          payload?.data?.map((item) => ({ label: item.title, value: item.id }))
        );
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
      }
    } catch (e) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: "Internal server error",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAUDITTemplates();
  }, []);
  const validationSchema = yup.object({
    // Title is required
    title: yup.string().required("Title is required"),

    // Due date is required

    // Service Unit is required
    template_form: yup
      .object()
      .shape({
        value: yup.string().required("Template is required"),
        label: yup.string(),
      })
      .nullable()
      .required("Template is required"),

    // At least one user must be selected (Multi-Select validation)
    users: yup
      .array()
      .of(
        yup.object().shape({
          value: yup.string().required(),
          label: yup.string().required(),
        })
      )
      .min(1, "At least one user must be selected")
      .required("Assigned To is required"),

    // Description is optional
    description: yup.string().required("Title is required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (valuess) => {
      setIsLoading(true);

      try {
        let response = await dispatch(
          drawerState === "edit"
            ? updateAudit({
                data: {
                  ...valuess,
                  template_form: valuess.template_form.value,
                  severity: valuess.severity.value,
                  users: valuess.users?.map((item) => item.value),
                  report: id,
                },
                id: values?.id,
              })
            : createAudit({
                data: {
                  ...valuess,
                  template_form: valuess.template_form.value,
                  severity: valuess.severity.value,
                  users: valuess.users?.map((item) => item.value),
                  report: id,
                },
              })
        );
        const { payload } = response;
        if (payload && payload.status) {
          await dispatch(
            setSnackbar({
              open: true,
              severity: "success",
              message:
                drawerState === "edit"
                  ? "Audit Task Updated Succesfully."
                  : "Audit Task Created Succesfully.",
            })
          );
          setIsOpenDrawer(false);
          getAllTasks();
          formik.resetForm();
        } else {
          await dispatch(
            setSnackbar({
              open: true,
              severity: "error",
              message: payload.message || "Internal server error",
            })
          );
        }
      } catch (error) {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: error || "Internal server error",
          })
        );
      }
      setIsLoading(false);
    },
  });

  const handleCloseDrawer = () => {
    formik.resetForm();
    setIsOpenDrawer(false);
  };

  //   const fetchAllserviceUnit = async () => {
  //     setIsLoading(true);

  //     try {
  //       let response = await dispatch(
  //         getAllServiceUnit({
  //           page_number: 1,
  //         })
  //       );
  //       const { payload } = response;
  //       if (payload?.status) {
  //         // setTemplateOptions(
  //         //   payload?.data?.map((item, idx) => ({
  //         //     label: item.name,
  //         //     value: item.id,
  //         //   }))
  //         // );
  //       } else {
  //         await dispatch(
  //           setSnackbar({
  //             open: true,
  //             severity: "error",
  //             message: payload?.message || "Internal server error",
  //           })
  //         );
  //       }
  //     } catch (error) {
  //       await dispatch(
  //         setSnackbar({
  //           open: true,
  //           severity: "error",
  //           message: "Internal server error",
  //         })
  //       );
  //     }

  //     setIsLoading(false);
  //   };
  //   useEffect(() => {
  //     fetchAllserviceUnit();
  //   }, []);

  const setTaskValues = () => {
    let data = {
      title: values?.title,
      description: values?.description,
      template_form:
        auditTemplates?.find(
          (item) => +item.value === +values?.template_form?.id
        ) ?? null,

      users: values?.users?.map((user) => ({
        value: user.id,
        label: user.first_name + " " + user.last_name,
      })),
      due_date: values.due_date
        ? new Date(values.due_date).toISOString().split("T")[0]
        : "",
      severity: severityOptions?.find(
        (item) => item.value === values?.severity
      ),
    };
    setInitialValues(data);
    formik.setValues(data);
  };
  useEffect(() => {
    if (drawerState !== "create") setTaskValues();
  }, [values, auditTemplates]);

  return (
    <>
      <CustomizedDialog
        className="modal-scroll"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        // slots={{ backdrop: Backdrop }}
        title={
          drawerState === "view"
            ? "Audit Detail"
            : drawerState === "create"
            ? "Create Audit"
            : "Edit Audit"
        }
        open={isOpenDrawer}
        handleClose={() => {
          handleCloseDrawer();
        }}
      >
        <DialogContent>
          <form className={drawerState === "view" && "form-disabled"}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Title
                  </Typography>
                  <TextField
                    disabled={drawerState === "view"}
                    fullWidth
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    placeholder="Enter Title"
                    size="small"
                    name="title"
                    {...formik.getFieldProps("title")}
                  />
                  {formik.touched.title && formik.errors.title && (
                    <div className="form-error-message">
                      {formik.errors.title}
                    </div>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Description
                  </Typography>
                  <TextField
                    disabled={drawerState === "view"}
                    fullWidth
                    id="outlined-basic"
                    label=""
                    multiline
                    rows="3"
                    variant="outlined"
                    placeholder="Enter Description"
                    size="small"
                    name="description"
                    {...formik.getFieldProps("description")}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <div className="form-error-message">
                      {formik.errors.description}
                    </div>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Due Date
                  </Typography>
                  <TextField
                    disabled={drawerState === "view"}
                    fullWidth
                    type="date"
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    placeholder="Select Due Date"
                    size="small"
                    name="Due Date"
                    InputProps={{
                      inputProps: {
                        min: new Date().toLocaleDateString("en-CA"),
                      }, // Restrict past dates
                    }}
                    {...formik.getFieldProps("due_date")}
                  />
                  {formik.touched.due_date && formik.errors.due_date && (
                    <div className="form-error-message">
                      {formik.errors.due_date}
                    </div>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Severity
                  </Typography>
                  <Selectt
                    options={severityOptions}
                    value={formik?.values?.severity}
                    onChange={(e) => {
                      formik.setFieldValue("severity", e);
                    }}
                    styles={customStyles}
                    placeholder="Select Severity"
                    menuPosition="fixed"
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    classNamePrefix="select"
                  />
                  {formik.touched.severity && formik.errors.severity && (
                    <div className="form-error-message">
                      {formik.errors.severity}
                    </div>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={12} xl={12}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Select Template
                  </Typography>
                  <Selectt
                    options={auditTemplates}
                    value={formik?.values?.template_form}
                    onChange={(e) => {
                      formik.setFieldValue("template_form", e);
                    }}
                    styles={customStyles}
                    placeholder="Select Template"
                    menuPosition="fixed"
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    classNamePrefix="select"
                    isLoading={isLoading}
                    isDisabled={
                      drawerState === "edit" && values.has_audit_submission
                    }
                  />
                  {formik.touched.template_form &&
                    formik.errors.template_form && (
                      <div className="form-error-message">
                        {formik.errors.template_form}
                      </div>
                    )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Select User (s)
                  </Typography>
                  <Selectt
                    styles={customStyles}
                    isMulti
                    size="small"
                    fullWidth
                    options={users}
                    value={formik?.values?.users}
                    onChange={(e) => {
                      formik.setFieldValue("users", e);
                    }}
                    classNamePrefix="select"
                    placeholder={"Select Users..."}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    menuPosition="fixed"
                  ></Selectt>
                  {formik.touched.users && formik.errors.users && (
                    <div className="form-error-message">
                      {formik.errors.users}
                    </div>
                  )}
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        {drawerState !== "view" && (
          <DialogActions>
            <Box className="modal-footers">
              <Stack spacing={2} direction="row">
                <Button
                  variant="contained"
                  className="primary-button"
                  disabled={isLoading}
                  onClick={formik.handleSubmit}
                >
                  {isLoading && (
                    <CircularProgress
                      size="1rem"
                      sx={{ mr: 1, zIndex: 1, position: "absolute" }}
                    />
                  )}
                  Save
                </Button>

                <Button
                  variant="outlined"
                  className="secondary-button"
                  disabled={isLoading}
                  onClick={handleCloseDrawer}
                >
                  Cancel
                </Button>
              </Stack>
            </Box>
          </DialogActions>
        )}
      </CustomizedDialog>

      <CustomizedDialog
        className="modal-scroll"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        title={"Update Status ( IN REVIEW => REVIEW COMPLETED )"}
        open={reviewCompleteOpen}
        handleClose={() => {
          setReviewCompleteOpen(false);
        }}
      >
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <Paper
              sx={{
                overflowX: "auto",
                whiteSpace: "pre-wrap",
                boxShadow: "none",
              }}
            >
              Are You Sure You want to mark the <b>{formik?.values?.title}</b>{" "}
              as reviewed and completed?
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            className="modal-footers"
            sx={{
              display: "flex",
              flexDirection: "row",
              cursor: "pointer",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Button
              sx={{ marginRight: "15px" }}
              variant="contained"
              className="primary-button"
              disabled={isLoading}
              onClick={() => {
                formik.setFieldValue("clickedButton", "ReviewComplete");
                formik.handleSubmit();
              }}
            >
              Confirm
            </Button>
            <Button
              variant="outlined"
              className="secondary-button"
              disabled={isLoading}
              onClick={() => setReviewCompleteOpen(false)}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </CustomizedDialog>
    </>
  );
};

export default CreateAudit;
